/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type MessageStateEnum = 'RECEIVED' | 'PREPARED' | 'SUBMITTED' | 'DELIVERED' | 'RETRY' | 'PUBLISH_FAILED' | 'DELIVERY_FAILED' | 'ASSUMED_DELIVERED';

export const MessageStateEnum = {

    RECEIVED: 'RECEIVED' as MessageStateEnum,

    PREPARED: 'PREPARED' as MessageStateEnum,

    SUBMITTED: 'SUBMITTED' as MessageStateEnum,

    DELIVERED: 'DELIVERED' as MessageStateEnum,

    RETRY: 'RETRY' as MessageStateEnum,

    PUBLISH_FAILED: 'PUBLISH_FAILED' as MessageStateEnum,

    DELIVERY_FAILED: 'DELIVERY_FAILED' as MessageStateEnum,

    ASSUMED_DELIVERED: 'ASSUMED_DELIVERED' as MessageStateEnum
};

